import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import ProviderLogo from "components/ProviderLogo";
import Translator from "services/Translator";
import { getProviderDisplayName, getProviderSlug, normalizeProviders } from "utils/providers";
import { resolveProviderLogo } from "utils/providerLogos";
import "./BrandsBar.scss";

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 3000,
  slidesToShow: 7,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 1199,
      settings: { slidesToShow: 5 },
    },
    {
      breakpoint: 991,
      settings: { slidesToShow: 4 },
    },
    {
      breakpoint: 767,
      settings: { slidesToShow: 3 },
    },
  ],
};

export default function BrandsBar({ providers = [], providersLoading = false }) {
  const brands = useMemo(() => {
    return normalizeProviders(providers)
      .map((provider) => {
        const logo = resolveProviderLogo(provider);
        if (!logo) return null;
        return {
          key: provider.provider_id || getProviderSlug(provider),
          slug: getProviderSlug(provider),
          alt: getProviderDisplayName(provider),
          provider,
        };
      })
      .filter(Boolean);
  }, [providers]);

  if (providersLoading || brands.length === 0) {
    return null;
  }

  return (
    <section className="brands-bar-section">
      <div className="brands-bar-container container-xxl">
        <Slider {...sliderSettings} className="brands-bar-slider">
          {brands.map((brand) => (
            <div className="brands-bar-slide" key={brand.key}>
              <Link
                to={`/providers/${brand.slug}`}
                className="provider-card brands-bar-card"
                hreflang={Translator.getSelectedLanguage().code}
                aria-label={brand.alt}
              >
                <div className="provider-card-inner">
                  <ProviderLogo provider={brand.provider} showFallbackText={false} />
                </div>
              </Link>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
